import { render } from "./TrainerSessionManagement.vue?vue&type=template&id=066cf0d4&scoped=true"
import script from "./TrainerSessionManagement.vue?vue&type=script&lang=js"
export * from "./TrainerSessionManagement.vue?vue&type=script&lang=js"

import "./TrainerSessionManagement.vue?vue&type=style&index=0&id=066cf0d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066cf0d4"]])

export default __exports__